import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Divider,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";
import ELDFileImportForm from "../EldExportImport/EldImportForm";

type Props = {
  isOpen: boolean;
  machineName: string | null;
  importId: string | null;
  onClose: () => void;
};

const useStyles = makeStyles((theme: Theme) => ({
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  dialogContent: {
    padding: theme.spacing(2),
    minHeight: 400,
  },
}));

const ImportFormWrapper = ({
  isOpen,
  machineName,
  importId,
  onClose,
}: Props) => {
  const classes = useStyles();

  const getFormComponent = () => {
    switch (machineName) {
      case "eld-file":
        return <ELDFileImportForm importId={importId} onSuccess={onClose} />;
      default:
        return null;
    }
  };

  const getTitle = () => {
    switch (machineName) {
      case "eld-file":
        return "ELD File Import";
      default:
        return "Import Data";
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: { minHeight: 500 },
      }}
    >
      <DialogTitle>
        <div className={classes.dialogTitle}>
          <span>{getTitle()}</span>
          <IconButton onClick={onClose} size="small">
            <Clear />
          </IconButton>
        </div>
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        {getFormComponent()}
      </DialogContent>
    </Dialog>
  );
};

export default ImportFormWrapper;
